module.exports = require("@material-ui/icons/ArrowDropDown");